<template>
  <div>
       <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" color="#FC4B4B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-container v-if="storage && sellerDet" pt-10>
      <v-form ref="form">
        <v-layout wrap justify-center>
          <v-flex xs12 lg6>
            <v-card>
              <v-layout wrap justify-center>
                <v-flex xs12 pt-6>
                  <span class="sofiaPro">Primary Details</span>
                </v-flex>
                <v-flex xs3 pb-4>
                  <v-progress-linear
                    height="2"
                    value="100"
                    color="#D8D6D6DE"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center>
                <v-flex>
                  <v-card v-if="coverImage == null">
                    <v-img
                      width="100%"
                      height="250px"
                      :src="require('../../../assets/Images/c2.png')"
                      class="align-end"
                    >
                      <v-layout wrap pa-7>
                        <v-flex xs3 text-center>
                          <v-card elevation="1">
                            <v-img
                              height="140px"
                              :src="require('../../../assets/Images/c2.png')"
                              v-if="profileImage == null"
                            >
                              <Propic
                                @stepper="profilewinStepper"
                                :height="'811'"
                                :width="'811'"
                                :heading="'Upload Profile Picture'"
                                :componentType="'coverImage'"
                              />
                            </v-img>
                            <v-img contain height="140px" :src="pic2" v-else>
                              <Propic
                                @stepper="profilewinStepper"
                                :height="'811'"
                                :width="'811'"
                                :heading="'Upload Profile Picture'"
                                :componentType="'coverImage'"
                              />
                            </v-img>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-img>
                    <v-card-text>
                      <CoverImageComp
                        @stepper="winStepper"
                        :height="'2118'"
                        :width="'8001'"
                        :heading="'Upload Cover Image'"
                        :componentType="'coverImage'"
                      />
                    </v-card-text>
                  </v-card>
                  <v-card v-else>
                    <v-img
                      width="100%"
                      height="250px"
                      :src="pic"
                      class="align-end"
                    >
                      <v-layout wrap pa-7>
                        <v-flex xs3 text-center>
                          <v-card elevation="1">
                            <v-img
                              height="140px"
                              :src="require('../../../assets/Images/c2.png')"
                              v-if="profileImage == null"
                            >
                              <Propic
                                @stepper="profilewinStepper"
                                :height="'811'"
                                :width="'811'"
                                :heading="'Upload Profile Picture'"
                                :componentType="'coverImage'"
                              />
                            </v-img>
                            <v-img height="140px" :src="pic2" v-else>
                              <Propic
                                @stepper="profilewinStepper"
                                :height="'811'"
                                :width="'811'"
                                :heading="'Upload Profile Picture'"
                                :componentType="'coverImage'"
                              />
                            </v-img>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-img>
                    <v-card-text>
                      <CoverImageComp
                        @stepper="winStepper"
                        :height="'2118'"
                        :width="'8001'"
                        :heading="'Upload Cover Image'"
                        :componentType="'coverImage'"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center v-if="sellerDet">
                <v-flex xs12 px-3 pt-3 text-left>
                  <span class="sofiaPro">Shop Name</span>
                  <v-text-field
                    dense
                    outlined
                    class="rounded"
                    :rules="[rules.required]"
                    v-model="sellerDet.shopName"
                    label="Shop Name"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Description</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required]"
                    v-model="sellerDet.description"
                    label="Description"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Location</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required]"
                    v-model="sellerDet.place"
                    label="address"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">City</span>
                  <v-text-field
                    disabled
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required]"
                    v-model="sellerDet.city"
                    label="City"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Pincode</span>
                  <v-text-field
                    
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required]"
                    v-model="sellerDet.pincode"
                    label="Pincode"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 pb-3 text-left px-3>
                  <span class="sofiaPro">Select location</span>
                </v-flex>

                <v-flex xs12 px-3>
                  <div id="map44"></div>
                </v-flex>
                <v-flex xs12 px-3 text-left pt-3>
                  <span class="sofiaPro">Email</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.email]"
                    v-model="sellerDet.email"
                    label="Email"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Whatsapp Number</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    :rules="[rules.required, rules.min]"
                    v-model="sellerDet.whatsapp"
                    label="Whatsapp Number"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Contact Person</span>
                  <v-text-field
                    class="rounded"
                    dense
                    label="Contact Person"
                    outlined
                    :rules="[rules.required]"
                    v-model="sellerDet.contactPerson"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Instagram Url</span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    v-model="sellerDet.instagram"
                    label="Instagram Url"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 px-3 text-left>
                  <span class="sofiaPro">Facebook URL </span>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    v-model="sellerDet.facebook"
                    label="Facebook URL"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 text-center py-7 px-3>
                  <v-btn
                    width="100%"
                    dark
                    block
                    color="#E31E24"
                    @click="profileUpdate"
                  >
                    Submit</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>
<script src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing"></script>
<script>
var map = [];
var state = "";
var city = "";
var pin = "";
var addrs = "";
import CoverImageComp from "./singleImage";
import Propic from "./profileImage";
import axios from "axios";
export default {
  props: ["storage"],
  components: {
    CoverImageComp,
    Propic,
  },
  data() {
    return {
      sellerDet: {
        photo: null,
        coverPhoto: null,
        shopName: '',
        description: '',
        place: '',
        city: '',
        pincode: '',
        lat: '',
        lon: '',
        contactPerson: '',
        email: '',
        whatsapp: '',
        facebook: '',
        instagram: '',
      },
      ServerError:false,
      conatctperson: null,
      instagram: null,
      facebook: null,
      Location: null,
      pic: null,
      pic2: null,
      cityy: null,
      locCity: null,
      state: null,
      pinn: null,
      shopName: null,
      email: null,
      whatsapp: null,
      contactPerson: null,
      lat: 0,
      lon: 0,
      sample: null,
      tab: null,
      changedlat: null,
      changedlon: null,
      sp: [],
      timeout: 3000,
      video: [],
      videoData: new FormData(),
      levelData: new FormData(),
      // level1: new formData(),
      urlgallery: [],
      url7: [],
      marker: [],
      msg: "",
      maps: null,
      showSnackBar: false,
      showCoverImage: "",
      coverImage: null,
      profileImage: null,
      coverData: new FormData(),
      appLoading: false,
      hiveGallery: [],
      gallery: new FormData(),
      description: "",
      name: "",
      phone: "",
      email: "",
      address: "",
      apiary: "",
      videoURL: "",
      displayName: "",
      keeperDescription: "",
      // rules: {
      //   required: (value) => !!value || "Required",
      //   min: (value) => value.length == 10 || "Invalid Phone",
      // },
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 10 || "Max 10 digits",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      imageFiles: [],
      sellerId: [],
      imageArray: [],
      flag: true,
      currentLatt: null,
      currentLonn: null,
      l: "",
      n: "",
    };
  },
  computed: {
    profileData() {
      if (this.sellerData) {
        return this.sellerData;
      } else return {};
    },
    fillProfile() {
      this.fullProfile();
    },
  },
  beforeMount() {
    if (this.storage) {
      this.sellerDet.shopName = this.storage.shopName;
      this.sellerDet.description = this.storage.description;
      this.sellerDet.email = this.storage.email;
      this.sellerDet.whatsapp = this.storage.socialmedialinks.whatsapp;
      this.sellerDet.contactPerson = this.storage.contactPerson;
      this.sellerDet.instagram = this.storage.socialmedialinks.instagram;
      this.sellerDet.facebook = this.storage.socialmedialinks.facebook;
      this.sellerDet.place = this.storage.place;
      this.sellerDet.city = this.storage.city;
      this.sellerDet.pincode = this.storage.pincode;
      this.sellerDet.lat = this.storage.location[1];
      this.sellerDet.lon = this.storage.location[0];
      this.coverImage = this.mediaURL + this.storage.coverPhoto;
      this.profileImage = this.mediaURL + this.storage.coverPhoto;
      this.pic = this.mediaURL + this.storage.coverPhoto;
      this.pic2 = this.mediaURL + this.storage.photo;

      // cosole.log("/////", this.coverImage)
      // console.log("star", this.sellerDet.lon);
    }
  },
  mounted() {
    this.getMap();
    // this.getGeoLoaction();
    if (this.sellerDet.lat) {
      this.marker = new google.maps.Marker({
        position: { lat: this.sellerDet.lat, lng: this.sellerDet.lon },
        map: this.maps,
      });
    }
  },

  methods: {
    displayLocation(latitude, longitude) {
      var hole;
      var vm = this;
      var geocoder;
      geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(latitude, longitude);

      const jm = geocoder.geocode(
        { latLng: latlng },
        function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              var add = results[0].formatted_address;
              var value = add.split(",");
              var count = value.length;
              addrs = results;
              console.log("Addressss", addrs);
              //  country=value[count-1];
              pin = value[count - 2];
              city = value[count - 3];
              // x.innerHTML = "city name is: " + city;
              var str = pin;
              var matches = str.match(/(\d+)/);
              if (matches) {
                pin = matches[0];
              }
              console.log("completete", city);

              // console.log("pinnnn", pin);
            } else {
              console.log("Address not found");
            }
            vm.cityy = city;
            vm.pinn = pin;
          } else {
            console.log("geocoder failed");
          }
        }
        // console.log("jmjjk", city)
      );
      // console.log("hole", hole);
      this.cityy = hole;

      // console.log("this.city =", this.city);
    },
    //// abow testing lines for geolocation
    getGeoLoaction() {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.gettingLocation = false;
          this.location = pos;
          this.currentLatt = this.location.coords.latitude;
          // console.log("lat is=", this.currentLatt);
          this.currentLonn = this.location.coords.longitude;
          // console.log("lon is=", this.currentLonn);
          this.displayLocation(this.currentLatt, this.currentLonn);
        },
        (err) => {
          this.gettingLocation = false;
          this.errorStr = err.message;
        }
      );
    },

    profilewinStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.profileImage = window_data.selectedFiles;
        this.pic2 = window_data.img;
      }
    },

    winStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImage = window_data.selectedFiles;

        this.pic = window_data.pic;
        this.coverImageUpload();
      }
    },
    galleryStepper(window_data) {
      if (window_data.type == "image") {
        this.imageArray = window_data.imageArray;
        this.imageFiles.push(window_data.selectedFiles);
      } else if (window_data.type == "imageRemoval") {
        this.imageFiles.splice(window_data.removalItem, 1);
        this.imageArray = window_data.imageArray;
      } else if (window_data.type == "imageDeletion") {
        if (window_data.response.status) this.getUser();
      }
      if (window_data.getData) {
        this.getUser();
      }
    },
    getMap() {
      var vm = this;
      var geocoder;
      geocoder = new google.maps.Geocoder();
      const gmap = new google.maps.Map(document.getElementById("map44"), {
        center: { lat: this.sellerDet.lat, lng: this.sellerDet.lon },
        zoom: 8,
      });
      this.maps = gmap;
      if (this.sellerDet.lat) {
        // alert(this.sellerDet.lat)
        // this.marker = new google.maps.Marker({
        //   position: { lat: this.sellerDet.lat, lng: this.sellerDet.lon },
        //   map: this.maps,
        // });
        //  this.marker = new google.maps.Marker({
        //   position: { lat: this.sellerDet.lat, lng:  this.sellerDet.lon },
        //   map: this.maps,
        //   title: "Hello World!",
        // });
      }

      google.maps.event.addListener(this.maps, "click", (e) => {
        geocoder.geocode(
          {
            latLng: e.latLng,
          },
          function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                map = results[0].address_components;
                // console.log(map, "llll");
                for (var i = 0; i < map.length; i++) {
                  if (map[i].types.includes("administrative_area_level_1")) {
                    vm.state = map[i].long_name;
                    // console.log("state is", vm.state);
                  }
                  if (map[i].types.includes("locality")) {
                    vm.city = map[i].long_name;
                    vm.sellerDet.city = vm.city;
                    // console.log("city is", vm.city);
                  }
                  if (map[i].types.includes("postal_code")) {
                    vm.pin = map[i].long_name;
                    vm.sellerDet.pincode = vm.pin;
                    console.log("pincode is", vm.pin);
                  }
                }
              } else {
                alert("No results found");
              }
            } else {
              alert("Geocoder failed due to: " + status);
            }
          }
          // console.log("loacl var state is=", this.country)
        );
        this.sellerDet.city = vm.city;
        this.state = vm.state;
        this.sellerDet.pincode = vm.pin;
        this.mark(e);
      });
    },
    mark(event) {
      this.lat = null;
      this.lon = null;

      this.marker.setMap(null);
      this.sellerDet.lat = event.latLng.lat();
      this.sellerDet.lon = event.latLng.lng();

      this.marker = new google.maps.Marker({
        position: { lat: this.sellerDet.lat, lng: this.sellerDet.lon },
        map: this.maps,
        title: "Hello World!",
      });
    },
    unselect(value, item) {
      this.hiveGallery.splice(value, 1);
      this.urlgallery.splice(value, 1);
      this.sp = item;
      // console.log("the image name is", this.sp);
      this.deleteFomGallery(item);
    },
    chooseCoverImage() {
      document.getElementById("coverImage").click();
    },
    browseToGallery(img) {
      for (let i = 0; i < img.length; i++) {
        this.hiveGallery.push(img[i]);
        this.url7.push(URL.createObjectURL(this.hiveGallery));
      }

      // this.hiveGallery = file.target.files;
      // console.log("gallery is", this.hiveGallery);
      // console.log("hive gallary is=", this.hiveGallery);
      // this.uploadToGallery()
    },

    coverImageUpload() {
      this.coverData.append("uid", this.$route.query.seller);
      this.coverData.append("coverImage", this.coverImage);

      axios({
        method: "post",
        url: "/seller/coverImage/upload",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.coverData,
      }).then((response) => {
        if (response.data.status) {
          this.showCoverImage = response.data.coverImage;
          this.coverData = new FormData();
        } else {
          alert("failed to update cover image");
        }
      });
    },

    profileUpdate() {
      if (this.$refs.form.validate()) {
        this.levelData.append("photo", this.profileImage);
        this.levelData.append("coverPhoto", this.coverImage);
        this.levelData.append("shopName", this.sellerDet.shopName);
        this.levelData.append("description", this.sellerDet.description);
        this.levelData.append("place", this.sellerDet.place);
        //  this.levelData.append("place", this.address);
        this.levelData.append("city", this.sellerDet.city);
        this.levelData.append("pincode", this.sellerDet.pincode);
        this.levelData.append("lat", this.sellerDet.lat);
        this.levelData.append("lon", this.sellerDet.lon);
        this.levelData.append("contactPerson", this.sellerDet.contactPerson);
        this.levelData.append("email", this.sellerDet.email);
        this.levelData.append("whatsapp", this.sellerDet.whatsapp);
        this.levelData.append("facebook", this.sellerDet.facebook);
        this.levelData.append("instagram", this.sellerDet.instagram);
        axios({
          method: "post",
          url: "seller/profile/level1",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: this.levelData,
        }).then((response) => {
          if (response.data.status) {
            this.showSnackBar = true;
            this.msg = response.data.msg;

            this.$emit("stepper", {
              // level:1,
              level: response.data.level,
            });
          } else {
            this.showSnackBar = true;
            this.msg = response.data.msg;
          }
          this.appLoading = false;
        })
        .catch((err) =>
        {
          console.log(err)
          this.ServerError =true;
        })
      }
    },
    //new line of codes

    getUser() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/view/" + this.$route.query.seller,
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.lat = response.data.data.sellerid.location[1];
          this.lon = response.data.data.sellerid.location[0];
          // this.sellerId=response.data.sellerid
          // console.log(this.lat, "this is our lat ");
          this.getMap();
          this.marker = new google.maps.Marker({
            position: { lat: this.lat, lng: this.lon },
            map: this.maps,
          });
        } else {
          this.appLoading = false;

          // alert("failed to get email");
        }
      });
    },
  },
};
</script>

<style>
.center >>> input {
  text-align: center;
  font-family: robotobold;
}
.v-text-field >>> label {
  font-family: sofialight;
  color: red;
}
.v-text-field--outlined {
  border-radius: 5px;
  font-family: sofialight;
  font-size: 18px;
}

#map44 {
  height: 400px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>
